import { MatMenuModule  } from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';

import { TimeService } from './time.service';
import { HttpService } from './http.service';

import { HttpClientModule } from '@angular/common/http'
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CalendarContainerComponent } from './calendar-container/calendar-container.component';
import { Signs2InMonthDisplayComponent } from './signs2-in-month-display/signs2-in-month-display.component';
import { Signs1InMonthDisplayComponent } from './signs1-in-month-display/signs1-in-month-display.component';
import { CurrentDayDisplayComponent } from './current-day-display/current-day-display.component';
import { DayComponentComponent } from './calendar-container/day-component/day-component.component';
import { TesterComponent } from './tester/tester.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MonthMenuComponent } from './month-menu/month-menu.component';
import { SignMenuComponent } from './sign-menu/sign-menu.component';
import { MonthDateComponent } from './month-date/month-date.component';
import { MoonNameDisplayComponent } from './moon-name-display/moon-name-display.component';
import { CurrentDayCuspDisplayComponent } from './current-day-cusp-display/current-day-cusp-display.component'
import { DayModalDataService } from './day-modal-data.service';
// import { CookieService } from 'ngx-cookie-service';



import { FormsModule } from '@angular/forms';
import { ModalModule } from './_modal';

// import { ngCookies } from 'angular-cookies';


@NgModule({
  declarations: [
    AppComponent,
    CalendarContainerComponent,
    Signs2InMonthDisplayComponent,
    Signs1InMonthDisplayComponent,
    CurrentDayDisplayComponent,
    CurrentDayCuspDisplayComponent,
    DayComponentComponent,
    TesterComponent,
    MonthMenuComponent,
    SignMenuComponent,
    // ngCookies,
    MonthDateComponent,
    MoonNameDisplayComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    MatMenuModule,
    MatButtonModule,
    MatButtonToggleModule,
    FormsModule,
    ModalModule,
    BrowserAnimationsModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [HttpService, TimeService, DayModalDataService],
  bootstrap: [AppComponent]
})
export class AppModule { }
